module.exports = __webpack_public_path__ + "static/media/alert-croped.03f09acc.wav";